import { render, staticRenderFns } from "./MdComponent.vue?vue&type=template&id=63eff895"
import script from "./MdComponent.vue?vue&type=script&lang=ts"
export * from "./MdComponent.vue?vue&type=script&lang=ts"
import style0 from "./MdComponent.vue?vue&type=style&index=0&id=63eff895&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports